import $ from 'jquery';
import Foundation from './3rd/_zf.js';
import { hdConfig } from './components/config.js';

import './components/global.js';
import './components/lighthouse.js';
import './components/back-to-top.js';
import './components/script-loader.js';
import { initMenu } from './components/menu.js';
import { initSocialShare } from './components/social-share.js';
//import SimpleBar from 'simplebar';
//import ResizeObserver from 'resize-observer-polyfill';
import { Fancybox } from '@fancyapps/ui';
//import select2 from 'select2';

//window.ResizeObserver = ResizeObserver;
//select2();

// Styles
import '../sass/3rd/_index.scss';
//import 'simplebar/dist/simplebar.css';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

// DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
    initMenu('nav.nav', '.main-nav');
    initSocialShare('[data-social-share]', { intents: [ 'facebook', 'x', 'print', 'send-email', 'copy-link', 'web-share' ] });
});

Fancybox.bind('.fcy-popup, .fcy-video, .banner-video a', {});
Fancybox.bind('.wp-block-gallery .wp-block-image a, [id^="gallery-"] a, [data-rel="lightbox"]', {
    groupAll: true, // Group all items
});

jQuery(function ($) {
    /** */
    const wpg__image = $('.wpg__image');
    wpg__image.find('a').on('click', function (e) {
        e.preventDefault();
        $(this).next('.image-popup').trigger('click');
    });

    /** */
    const wpg__thumb = $('.wpg__thumb');
    wpg__thumb.find('a').on('click', function (e) {
        e.preventDefault();
    });
});
// js countdown
jQuery(document).ready(function($) {
    var endTime = $('#countdown').data('deadline');
    function startCountdown(endTime, displayElements) {
      var countdownInterval = setInterval(function() {
          var now = Math.floor(Date.now() / 1000);
          var timeLeft = endTime - now;
          if (timeLeft <= 0) {
              clearInterval(countdownInterval);
              return;
          }
          var days = Math.floor(timeLeft / (60 * 60 * 24));
          var hours = Math.floor((timeLeft % (60 * 60 * 24)) / (60 * 60));
          var minutes = Math.floor((timeLeft % (60 * 60)) / 60);
          var seconds = timeLeft % 60;

          $(displayElements.day).text(days);
          $(displayElements.hour).text(hours < 10 ? '0' + hours : hours);
          $(displayElements.minute).text(minutes < 10 ? '0' + minutes : minutes);
          $(displayElements.second).text(seconds < 10 ? '0' + seconds : seconds);
      }, 1000);
    }
    var displayElements = {
        day: $('.countdown-time .day'),
        hour: $('.countdown-time .hour'),
        minute: $('.countdown-time .minute'),
        second: $('.countdown-time .second')
    };
    startCountdown(endTime, displayElements);
});
// 
jQuery(document).ready(function () {
  jQuery('.lists-faq .tab-title').click(function () {
    var $tabContent = jQuery(this).next('.tab-content');
    var $toggleItem = jQuery(this).closest('.toggle-item');
    // Toggle active class
    $toggleItem.toggleClass('active');
    if ($toggleItem.hasClass('active')) {
        var scrollHeight = $tabContent[0].scrollHeight;
        $tabContent.css('max-height', scrollHeight + 'px');
    } else {
        $tabContent.css('max-height', '0');
    }
  });
});